"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

export default function CollabWithPartner({ collabData }) {

    return (
        <div className="w-full my-6 md:mt-10 lg:mt-14">
            <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
                <div className="text-left" >
                    <h2 className="font-bold text-black text-2xl sm:text-3xl lg:text-[42px] font-saansBold mb-3 md:mb-8">MoUs Signed</h2>
                </div>
                <div className="relative w-full">

                    <Swiper
                        modules={[Autoplay, Navigation]}
                        navigation={{
                            nextEl: ".swiper-button-next-card",
                            prevEl: ".swiper-button-prev-card",
                        }}
                        spaceBetween={24}
                        loop={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: { slidesPerView: 1.1 },
                            640: { slidesPerView: 1.3 },
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 2.5 },
                            1280: { slidesPerView: 3 },
                        }}
                    >
                        {collabData.map((card, index) => (
                            <SwiperSlide key={index}>

                                <div className="bg-white shadow-sm overflow-hidden hover:shadow-lg 
                                transition-transform hover:-translate-y-1 border-[0.2px] border-black/60  hover:border-transparent
                                h-[200px] md:h-[400px] flex flex-col">

                                    <div className="hover:bg-[#FFA201]  transition-all duration-300 px-5 
                                    flex flex-col justify-center h-[100px] md:h-[150px]">

                                        <p className="text-[16px] md:text-[18px] lg:text-[20px] font-medium leading-snug">
                                            {card.alt}
                                        </p>
                                    </div>

                                    <div className="relative w-full h-[180px] sm:h-[220px] md:h-[350px] bg-white">
                                        <Image
                                            src={card.img}
                                            alt={card.alt}
                                            fill
                                            className="object-cover object-center"
                                            priority
                                        />
                                    </div>

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>
            </div>
        </div>
    );
}
